import { GridColumnVisibilityModel } from '@mui/x-data-grid-pro';
import * as React from 'react';
import { WatchListFilterCounts } from 'services/clients/watchList';
import { ActionButtons } from './actions/ActionButtons';
import { Filters } from './filters';
import { Search } from './Search';
import { StatusSelector } from './status-selector';

interface Props {
  filterCounts?: WatchListFilterCounts;
  columnVisibilityModel: GridColumnVisibilityModel;
  onColumnVisibilityChange: (newModel: GridColumnVisibilityModel) => void;
}

export const Controls: React.FC<Props> = ({
  filterCounts,
  columnVisibilityModel,
  onColumnVisibilityChange,
}) => {
  return (
    <div className="!mt-8 flex flex-col space-y-8 w-full">
      <Search />
      <StatusSelector filterCounts={filterCounts} />
      <div className="flex justify-between 2xl:flex-col-reverse 2xl:space-y-reverse 2xl:space-y-4">
        <Filters />
        <ActionButtons
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityChange={onColumnVisibilityChange}
        />
      </div>
    </div>
  );
};
Controls.displayName = 'TrackAndTrace.Controls';
